export default "__VITE_ASSET__De0JjRKw__"